import { createStore } from "vuex";
import users from "./modules/users";

export default createStore({
  state: {
    user: null,
    authChecking: false,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setAuthChecking(state, checking) {
      state.authChecking = checking;
    },
  },
  getters: {
    userCompany: (state) => {
      return state.user?.company || null;
    },
    userRole: (state) => {
      return state.user?.role || 'user';
    },
    isSuperAdmin: (state) => {
      return state.user?.role === 'superadmin';
    },
    isOwner: (state) => {
      return state.user?.role === 'owner';
    },
    isAdmin: (state) => {
      return ['admin', 'owner', 'superadmin'].includes(state.user?.role);
    },
    canManageUsers: (state) => {
      return ['admin', 'owner', 'superadmin'].includes(state.user?.role);
    },
    canSeeAllData: (state) => {
      return state.user?.role === 'superadmin' || state.user?.role === 'owner';
    }
  },
  actions: {
    async loginUser({ commit }, userData) {
      const response = await users.actions.loginUser({ commit }, userData);
      if (response.ok) {
        commit("setUser", response.user);
      }
      return response;
    },
    async checkAuth({ commit }) {
      return await users.actions.checkAuth({ commit });
    },
    async logOut({ commit }) {
      try {
        await users.actions.logOut({ commit });
      } finally {
        commit("setUser", null);
        commit("setAuthChecking", false);
      }
    },
    async forgotPassword(_, data) {
      return await users.actions.forgotPassword(_, data);
    },
    async verifyOtp(_, data) {
      return await users.actions.verifyOtp(_, data);
    },
    async setNewPassword(_, data) {
      return await users.actions.setNewPassword(_, data);
    },
    async getApprovedWorkOrders(_, filters = {}) {
      return await users.actions.getApprovedWorkOrders(_, filters);
    },
    async getSubmittedInvoices(_, filters = {}) {
      
      return await users.actions.getSubmittedInvoices(_, filters);
    },
    async getPaidInvoices(_, filters = {}) {
      return await users.actions.getPaidInvoices(_, filters);
    },
    async getDeclinedInvoices(_, filters = {}) {
      return await users.actions.getDeclinedInvoices(_, filters);
    },
    async getReturnInvoices(_, filters = {}) {
      return await users.actions.getReturnInvoices(_, filters);
    },
    async getOwnerDashboard(_, filters = {}) {
      return await users.actions.getOwnerDashboard(_, filters);
    },
    async getRowAttachments(_, data) {
      return await users.actions.getRowAttachments(_, data);
    },
    async uploadRowAttachment(_, data) {
      return await users.actions.uploadRowAttachment(_, data);
    },
    async getAllCategories() {
      return await users.actions.getAllCategories();
    },
    async getAllStatuses() {
      return await users.actions.getAllStatuses();
    },
    async getWorkOrderStatuses() {
      return await users.actions.getWorkOrderStatuses();
    },
    async getCompanies() {
      return await users.actions.getCompanies();
    },
    async getUsers(_, filters = {}) {
      return await users.actions.getUsers(_, filters);
    },
    async createUser(_, userData) {
      return await users.actions.createUser(_, userData);
    },
    async updateUser(_, data) {
      return await users.actions.updateUser(_, data);
    },
    async resendCredentials(_, userId) {
      return await users.actions.resendCredentials(_, userId);
    },
    async toggleUserActive(_, userId) {
      return await users.actions.toggleUserActive(_, userId);
    },
    async deleteUser(_, userId) {
      return await users.actions.deleteUser(_, userId);
    },
  },
});


